import { gql } from "@apollo/client";

export const recipientPracticeFieldsFragment = gql`
  fragment RecipientPracticeFields on Provider {
    ...ProviderFields
  }
`;
